export const handleWhatsAppClick = (customMessage) => {
  const phoneNumber = '5551995420336'; // (51) 99542-0336
  const defaultMessage = 'Olá Hiperpan! Gostaria de mais informações.';
  const text = encodeURIComponent(customMessage || defaultMessage);
  
  window.open(`https://wa.me/${phoneNumber}?text=${text}`, '_blank', 'noopener,noreferrer');
};